module.exports = __webpack_public_path__ + "static/img/db.4c40d2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/db.jpg
// module id = jBdj
// module chunks = 0